import React from 'react';
import { string } from 'prop-types';
import { Box } from '@styleseat/ui';
import { TextInput } from '../../../ui';
import ErrorMessage from './ErrorMessage';
import Label from './Label';

export default function TextFieldRow({
  name,
  error,
  placeholder,
  ...restProps
}) {
  return (
    <Box paddingX={12}>
      <Label>{name}</Label>
      <TextInput
        placeholder={placeholder}
        appearance="stretched"
        style={{
          paddingLeft: 0,
        }}
        {...restProps}
      />
      <ErrorMessage message={error} />
    </Box>
  );
}

TextFieldRow.propTypes = {
  name: string.isRequired,
  error: string,
  placeholder: string.isRequired,
};

TextFieldRow.defaultProps = {
  error: null,
};
